export default __webpack_public_path__ + "static/flow-moneybox-85b0043d44ea547effd297c860e78009.jpg";